import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MEDDICSelectorComponent } from './meddic-selector/m-e-d-d-i-c-selector.component';
import { MeddicSectionComponent } from './meddic-section/meddic-section.component';
import { MEDDICTitleComponent } from './meddic-title/m-e-d-d-i-c-title.component';
import { MEDDICProgressBarComponent } from './meddic-section/meddic-progress-bar/meddic-progress-bar.component';
import { AsyncUiModule } from '@vendasta/uikit';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MeddicNotesModule } from './meddic-section/meddic-notes/meddic-notes.module';
import { MeddicNotesService } from './meddic-section/meddic-notes.service';
import { MeddicErrorsModule } from './meddic-section/meddic-errors/meddic-errors.module';

@NgModule({
  declarations: [MEDDICSelectorComponent, MeddicSectionComponent, MEDDICTitleComponent, MEDDICProgressBarComponent],
  exports: [MeddicSectionComponent, MEDDICProgressBarComponent],
  imports: [
    CommonModule,
    AsyncUiModule,
    MatTooltipModule,
    MatIconModule,
    TranslateModule,
    MatProgressBarModule,
    MatExpansionModule,
    MatButtonModule,
    MatSelectModule,
    TranslateModule,
    MeddicNotesModule,
    MeddicErrorsModule,
  ],
  providers: [MeddicNotesService],
})
export class MeddicModule {}
